import {ECompanyNewsTab} from './definitions';

export default {
  tabs: {
    [ECompanyNewsTab.BLOG]: 'Blog',
    [ECompanyNewsTab.CASES]: 'Case studies',
  },
};
